import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { ApiResponse } from '../interfaces/api-response';

export interface TrustedDevice {
  id: number;
  device_name: string;
  ip_address: string | null;
  last_used_at: string;
  expires_at: string;
  created_at: string;
}

export interface TrustedDevicesResponse {
  devices: TrustedDevice[];
}

@Injectable({
  providedIn: 'root'
})
export class TrustedDevicesService {
  constructor(private http: HttpService) {}

  getTrustedDevices(): Observable<ApiResponse<TrustedDevicesResponse>> {
    return this.http.get<ApiResponse<TrustedDevicesResponse>>('v2/extranet/trusted-devices');
  }

  revokeDevice(deviceId: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>('v2/extranet/trusted-devices/revoke', {
      body: { device_id: deviceId }
    });
  }

  revokeAllDevices(): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>('v2/extranet/trusted-devices/revoke-all');
  }
}
